import { Box } from "@mui/material";
import useColors from "../../../../api/hooks/useColors";
import SvgToIcon from "../../../../icons/SvgToIcon";
import { detectionIcons } from "../../../stack/environment/icons/iconExport";

const DetectionLabelIcon = ({ sx = {} }) => {
  const colors = useColors();
  return (
    <Box
      display="flex"
      sx={{
        alignItems: "center",
        justifyContent: "center",
        borderRadius: "6px",
        padding: "3px",
        background: colors.error_8percent,
        boxShadow: "0px 0px 1px 0px " + colors.error_48percent,
        ...sx,
      }}
    >
      <SvgToIcon
        IconLogo={detectionIcons.DetectionRed}
        style={{
          width: "16px",
          height: "16px",
        }}
      />
    </Box>
  );
};

export default DetectionLabelIcon;
